var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bootstrapLoaded)?_c('DataCaptureSurvey',{attrs:{"clientId":_vm.clientId,"investor":_vm.investor,"advisor":_vm.advisor,"featureFlags":_vm.featureFlags,"viewMode":"investor"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }